export const TaskClassEnum = {
    TaskQuestion: 'TaskQuestion',
    TaskSerie: 'TaskSerie',
    TaskRandomSerie: 'TaskRandomSerie',
    TaskQuestionReporting: 'TaskQuestionReporting',
    TaskChapterReporting: 'TaskChapterReporting',
    TaskMicroskillReporting: 'TaskMicroskillReporting'
};
